export const MODAL_TYPE_CATEGORY_ACTIONS = 'category-actions';
export const MODAL_TYPE_FORUM_ACTIONS = 'forum-actions';
export const MODAL_TYPE_POST_ACTIONS = 'post-actions';
export const MODAL_TYPE_COMMENT_ACTIONS = 'comment-actions';
export const MODAL_TYPE_CATEGORY_MANAGER_ACTIONS = 'category-manager-actions';
export const MODAL_TYPE_CREATE_POST_ACTIONS_MOBILE = 'create-post-actions-mobile';
